import { IMAGES } from "@/assets/IMAGES";
import { Outlet } from "react-router-dom";
import { Separator } from "@/components/ui/Separator";
import { useState } from "react";
import { cn } from "@/lib/utils";

export interface KioskLayoutContext { 
  setTitle: React.Dispatch<React.SetStateAction<string>>
  setTitleClassname: React.Dispatch<React.SetStateAction<string>>
}

export default function KioskLayout() {
  const [title, setTitle] = useState("Self Service Kiosk");
  const [titleClassname, setTitleClassname] = useState("");

  return (
    <main className="w-full flex flex-col items-center justify-center p-0 md:p-1 bg-gray-50">
      <div className="m-0 md:m-3 w-[80%]">
        {/* Header */}
        <div className="flex py-3 md:py-0 flex-col items-center justify-center md:flex-row md:justify-between">
          <div className="flex items-center">
            <img
              src={IMAGES.logo_icon}
              alt="logo"
              className="w-[5rem] h-[5rem] object-contain"
            />
            <p className="text-primary text-[1.4rem] font-bold">QMS</p>
          </div>
          <h4 className={cn("capitalize my-2 md:my-0 text-[1.5rem] md:text-[2rem]", titleClassname)}>
            {title}
          </h4>
        </div>
        <Outlet context={{ setTitle, setTitleClassname } as KioskLayoutContext} />
        <Separator
          orientation="horizontal"
          className="h-[.1rem] w-[100%] bg-gray-300"
        />
        {/* Footer */}
        <div className="flex items-center justify-between my-4">
          <div className="bg-gray-300 text-gray-500 p-2 rounded-full">
            <p className="text-[.9rem]">Information & Contact</p>
          </div>
        </div>
      </div>
    </main>
  )
}
